const queryAll = (selector, target = document) => {
  const items = target.querySelectorAll(selector);

  return items ? Array.from(items) : [];
};

export default queryAll;
